import React from 'react';
import Chat from "./teleHealth/Chat";
import {HashRouter as Router, Route,} from 'react-router-dom'
import createMuiTheme from "@material-ui/core/styles/createMuiTheme";
import ThemeProvider from "@material-ui/styles/ThemeProvider";
import MobileChat from "./mobile-telehealth/MobileChat";
import {getOS} from "./utis/util";
import {PlatformType} from "./utis/customEnum";
import {GrayLog} from "./grayLog/grayLog";
import {GlobalConfig} from "./appConfig";
import FAQ from "./faq/faq";

const theme = createMuiTheme({
    typography: {
        button: {
            textTransform: 'none'
        }
    }
});

function App() {
    console.log(`Build Time: 2022-09-08 16:30 ${GlobalConfig.envType}`);
    GrayLog.initialize();
    return (
        <Router>
            <ThemeProvider theme={theme}>
                <div>
                    <Route path='/telehealth/:meetingInfo' exact
                           component={(getOS() === PlatformType.iOS || getOS() === PlatformType.android) ? MobileChat : Chat}/>
                    <Route path='/mtelehealth/:meetingInfo' exact component={MobileChat}/>
                    <Route path='/faq' exact component={FAQ}/>
                </div>
            </ThemeProvider>
        </Router>
    );
}

export default App;
